<template>
  <PageLayout>
    <!-- Main Content -->
    <template #main>
      <h1>App Playground</h1>
      <p>This is the main content area of the App Playground.</p>

      <DetailFilterRow  class="my-2" />

    </template>

    <!-- Sidebar -->
    <template #sidebar>
      <PageSidebar title="Playground" :show-divider="false">
        <!-- Sidebar Header (optional - überschreibt default title) -->
        <!-- <template #header> </template> -->

        <!-- Sidebar Body -->
        <template #body>
          <SideNotes
            title="Letzte Exporte"
            subtitle="Zuletzt geladene Reports und Daten"
            :items="recentExports"
            @item-click="handleExportClick"
          />
        </template>

        <!-- Sidebar Footer (optional) -->
        <template #footer>
          <button class="action-button">Complete Playground</button>
        </template>
      </PageSidebar>
    </template>
  </PageLayout>
</template>

<script>
import PageLayout from '@/componentsv3/PageLayout.vue';
import PageSidebar from '@/componentsv3/PageSidebar.vue';
import SideNotes from '@/componentsv3/SideNotes.vue';
import DetailFilterRow from '@/componentsv3/DetailFilterRow.vue';

export default {
  name: 'PlaygroundAndSidebar',

  components: {
    PageLayout,
    PageSidebar,
    SideNotes,
    DetailFilterRow
  },

  data() {
    return {
      recentExports: [
        {
          title: 'Sales Performance Cockpit',
          filename: '25T3 Deutschland.pdf',
          time: 'vor 3 Tagen',
          size: '2.3 MB',
          type: 'PDF'
        },
        {
          title: 'Sales Performance Cockpit',
          filename: '25T3 Deutschland.pdf',
          time: 'vor 3 Tagen',
          size: '2.3 MB',
          type: 'PDF'
        },
        {
          title: 'Sales Performance Cockpit',
          filename: '25T3 Deutschland.pdf',
          time: 'vor 3 Tagen',
          size: '2.3 MB',
          type: 'PDF'
        },
        {
          title: 'Sales Performance Cockpit',
          filename: '25T3 Deutschland.pdf',
          time: 'vor 3 Tagen',
          size: '2.3 MB',
          type: 'PDF'
        },
        {
          title: 'Sales Performance Cockpit',
          filename: '25T3 Deutschland.pdf',
          time: 'vor 3 Tagen',
          size: '2.3 MB',
          type: 'PDF'
        }
      ]
    };
  },

  methods: {
    handleExportClick(item) {
      console.log('Export clicked:', item);
      // Hier kann z.B. ein Download ausgelöst werden
    },
  }
}
</script>

<style lang="scss">
.container-fluid {
  padding-left: unset !important;
  padding-right: unset !important;
}
</style>

<style lang="scss" scoped>
.custom-title {
  font-size: 28px;
  font-weight: 400;
  color: #f50537;
}

.action-button {
  width: 100%;
  padding: 12px 24px;
  background-color: #f50537;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #d42f3e;
  }
}


</style>
